import styled from 'styled-components';

export const SVGCustomSizeContainer = styled.div`
  svg {
    ${(props) =>
      props.size &&
      `width: ${props.size};
        height: ${props.size};
      `}
  }
`;
